module.exports = __webpack_public_path__ + "img/icon_white_bell.049d671c.svg";